import { createAction, stringDuckCreator } from '@atc/modular-redux';

export default function dealerSetPaidSearchIdCreator({
    namespace = '',
    store = 'psid',
    storePrefix,
    initialState = '',
} = {}) {
    return stringDuckCreator({
        initialState,
        namespace,
        store,
        storePrefix,
    }).extend({
        creators: ({ types }) => ({
            setPaidSearchId: createAction(types.SET),
        }),
    });
}
